import { ca } from '@cian/analytics';

const baseEvent = {
  name: 'oldevent',
  category: 'request'
};

export function trackPopupOpened() {
  const event = Object.assign({
    action: 'open'
  }, baseEvent);
  ca('event', event);
}

export function trackPopupClosed(options: {formSent: boolean}) {
  const event = Object.assign({
    action: options.formSent ? 'close_ok' : 'close'
  }, baseEvent);
  ca('event', event);
}

export function trackFormTryToSend() {
  const event = Object.assign({
    action: 'TryToSend'
  }, baseEvent);
  ca('event', event);
}

export function trackFormSent() {
  const event = Object.assign({
    action: 'send'
  }, baseEvent)
  ca('event', event);
}

export function trackFormError() {
  const event = Object.assign({
    action: 'error'
  }, baseEvent);
  ca('event', event);
}


// WEBPACK FOOTER //
// ./src/bundles/user_claims/tracking.ts